var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowReturnTableRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50125 3.87748H8.75165L6.87977 2.00559L8.01036 0.875L11.2582 4.12279C11.5728 4.43744 11.5728 4.94407 11.2582 5.25339L8.03703 8.47452L6.90643 7.34392L8.77831 5.47204H4.50125C3.17867 5.47204 2.10674 6.38398 2.10674 7.49858C2.10674 8.61317 3.184 9.52512 4.50125 9.52512H5.3012V11.125H4.50125C2.29873 11.125 0.506838 9.49845 0.506838 7.49858C0.506838 5.49871 2.29873 3.87214 4.50125 3.87214V3.87748Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowReturnTableRight);
export default __webpack_public_path__ + "static/media/ic_arrow_return_table_right.de5fce1fccbdb108a0db263109f828dc.svg";
export { ForwardRef as ReactComponent };